import { Card, Form } from 'antd';
import { getPhotoConfigs } from 'routes/installation/const/config/photo';
import { useIntl } from 'react-intl';
import { VFC } from 'react';
import { useInstallMeterStepsStore } from '../../components/store';
import { useStore } from '../../useStore';
import { useScrollTopOnMount } from '../../../../hooks/useScrollTopOnMount';
import { PhotoStepForm } from './slice';
import { PhotoUploader } from './PhotoUploader';

export const PhotoStepContent: VFC = () => {
  const { setNextStep } = useInstallMeterStepsStore();
  const { setPhotoStepValues, enmonMeter } = useStore();
  const intl = useIntl();

  useScrollTopOnMount();

  const handleSubmit = (values: PhotoStepForm) => {
    setPhotoStepValues(values);
    setNextStep();
  };

  const handleValuesChange = (changedVals: Partial<PhotoStepForm>) => {
    setPhotoStepValues(changedVals as any);
  };

  const config = enmonMeter ? getPhotoConfigs(intl, enmonMeter) : [];

  return (
    <Card bodyStyle={{ padding: 0 }} bordered={false}>
      <Form
        id="photoStepForm"
        layout="vertical"
        name="photo"
        onFinish={handleSubmit}
        onValuesChange={handleValuesChange}
      >
        {config.map(photoSliceConfig => (
          <PhotoUploader key={photoSliceConfig.formItemName} {...photoSliceConfig} />
        ))}
      </Form>
    </Card>
  );
};
